document.querySelectorAll('[data-alt-collection]').forEach((root) => {
  const buttons = [...root.querySelectorAll('[data-alt-filter]')];
  const cards = [...root.querySelectorAll('[data-alt-category]')];
  const videos = [...root.querySelectorAll('[data-alt-collection-video]')];
  const count = root.querySelector('[data-alt-count]');

  function selectCategory(selected) {
    buttons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.altFilter === selected)));
    let visible = 0;
    cards.forEach((card) => {
      card.hidden = selected !== 'all' && card.dataset.altCategory !== selected;
      if (!card.hidden) visible++;
    });
    if (count) count.textContent = visible;
    videos.forEach((video) => { if (video.closest('[data-alt-category]')?.hidden) video.pause(); });
  }

  buttons.forEach((button) => button.addEventListener('click', () => {
    selectCategory(button.getAttribute('aria-pressed') === 'true' ? 'all' : button.dataset.altFilter);
  }));
  const requested = new URLSearchParams(location.search).get('category');
  selectCategory(buttons.some((button) => button.dataset.altFilter === requested) ? requested : 'all');

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
      const video = entry.target;
      if (entry.isIntersecting && !video.closest('[data-alt-category]')?.hidden) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    }), { threshold: 0.15 });
    videos.forEach((video) => observer.observe(video));
  }
});
